export default class ListActivitiesController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    schoolYearText,
    UtilService,
    ActivityService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.schoolYearText = schoolYearText;
    this.UtilService = UtilService;
    this.ActivityService = ActivityService;

    this.months = this.UtilService.getAllMonths();
  }

  loadActivities() {
    this.ActivityService.get(this.selectedMonth, true).then(result => {
      this.activities = result;
      let toastText = 'Pomyślnie pobrano zajęcia';
      if (this.activities.length === 0) {
        toastText = 'Nie masz zajęć na ten miesiąc';
      }

      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent(toastText)
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(errorMessage => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(errorMessage)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  getMonthName(monthNumber) {
    return this.UtilService.getMonthName(monthNumber);
  }

  edit() {
    this.$mdDialog.hide();
    this.$state.go('modules.settings.step6');
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
